module.exports = __webpack_public_path__ + "static/media/master.82549f40.svg";